import { useMemo, useState } from 'react';
import { throttle } from '../lib/Utils/throttle';
import { useEventListener } from '../lib/Utils/useEventListener';
import { useIsomorphicLayoutEffect } from '../lib/Utils/useIsomorphicLayoutEffect';

const THROTTLE_TIMEOUT = 50;

export function useThrottledElementSize(): [
	React.Dispatch<React.SetStateAction<HTMLElement | null>>,
	{ width: number; height: number }
] {
	const [ref, setRef] = useState<HTMLElement | null>(null);
	const [elWidth, setElWidth] = useState<number>(0);
	const [elHeight, setElHeight] = useState<number>(0);

	const handleSize = throttle(() => {
		const width: number =
			// eslint-disable-next-line no-void
			(ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0;

		setElWidth(width);

		const height: number =
			// eslint-disable-next-line no-void
			(ref === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0;
		setElHeight(height);
	}, THROTTLE_TIMEOUT);

	useEventListener('resize', handleSize);

	useIsomorphicLayoutEffect(() => {
		handleSize();
	}, [
		// eslint-disable-next-line no-void
		ref === null || ref === void 0 ? void 0 : ref.offsetHeight,
		// eslint-disable-next-line no-void
		ref === null || ref === void 0 ? void 0 : ref.offsetWidth,
	]);

	const size = useMemo(
		() => ({ width: elWidth, height: elHeight }),
		[elWidth, elHeight]
	);

	return [setRef, size];
}
